module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_3016.2a18bc17.png";